import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';

@Component({
    selector: 'app-add-btn-renderer',
    templateUrl: './add-btn-renderer.component.html',
    styleUrls: ['./add-btn-renderer.component.scss'],
    standalone: false // NOSONAR
})
export class AddBtnRendererComponent implements ICellRendererAngularComp {
  resolutionId:any;
  addCheck: boolean=true;
  errorMessage: any;
  protected params: any;
  isAccessible: boolean = true;

  constructor( private readonly router : Router, private readonly aetStateService : AetStateService,public constants: Constants,) { }

  refresh(params: ICellRendererParams): boolean {
    throw new Error(
      `Error while refreshing renderer component. INFO-${params}`
    );
  }

  agInit(params: any): void {
    // this.checkRoles();
    this.params = params;
    this.resolutionId = this.params.data.resolution_id;
    if(this.router.url.includes('/dashboard/resolutions')){
      this.addCheck=true;
    }
    else{
      this.addCheck=false;
    }
  }

  async checkRoles() {
    await this.aetStateService.getRoles();
    const roles = this.aetStateService.getroleState();
    const userRoles = JSON?.parse(roles);
    if(userRoles && (userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter) || 
    userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_NAMC_Planner) || 
    userRoles.includes(this.constants.LIOS_UAC_AET_LP) || userRoles.includes(this.constants.LIOS_UAC_MTMUS_Planner) 
      ||userRoles.includes(this.constants.LIOS_UAC_MTMUS_Negotiator)||userRoles.includes(this.constants.LIOS_UAC_Portal_Administrator)
      ||userRoles.includes(this.constants.LIOS_UAC_Reporting_Admin)||userRoles.includes(this.constants.LIOS_UAC_Reporting_User)
      ||userRoles.includes(this.constants.LIOS_UAC_Route_Planner)||userRoles.includes(this.constants.LIOS_UAC_SCV_Admin)
      ||userRoles.includes(this.constants.LIOS_UAC_Security_Admin)||userRoles.includes(this.constants.LIOS_UAC_TEMA_AF)
      ||userRoles.includes(this.constants.LIOS_UAC_TEMA_Budgeting)||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_AM)
      ||userRoles.includes(this.constants.LIOS_UAC_TEMA_OPS_Specialist)||userRoles.includes(this.constants.LIOS_UAC_TEMA_Purchasing)
      ||userRoles.includes(this.constants.LIOS_UAC_TEMA_LC)||userRoles.includes(this.constants.LIOS_UAC_TPT_Admin)
      ||userRoles.includes(this.constants.LIOS_UAC_TSCS_Admin)||userRoles.includes(this.constants.LIOS_UAC_WT_Administrator))){
      this.isAccessible = true;
    }
    else{
      // this.router.navigate([`/home`]);  // NOSONAR
      this.isAccessible = false;
    }
    // if (userRoles && userRoles.includes(this.constants.LIOS_UAC_Admin) || userRoles.includes(this.constants.LIOS_UAC_LP_Filter ||
    //   userRoles.includes(this.constants.LIOS_UAC_TEMA_Ops) || userRoles.includes(this.constants.LIOS_UAC_TaskManagerUser)) {
    //   // this.isAccessible = true;
    // } else {
    //   this.router.navigate([`/home`]);
    // }
  }
  addResolutionOrders() {
      this.router.navigate(['/dashboard/resolutions/add-resolution-orders']);
      this.resolutionId = this.params.data.resolution_id;
      localStorage.setItem('resolutionId', this.resolutionId);  
}
}
